import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';

@Component({
  selector: 'hazmatsuite-next-inline-edit-label',
  templateUrl: './inline-edit-label.component.html',
  styleUrls: ['./inline-edit-label.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InlineEditLabelComponent {
  @ViewChild('input') inputField?: ElementRef;

  public initialValue = '';

  @Input() set label(val: string) {
    this.initialValue = val;
  }

  @Output() save = new EventEmitter<string>();

  public isEditMode = false;

  public saveChanges(value: string): void {
    this.initialValue = value;
    this.save.next(value);
    this.isEditMode = false;
  }

  public cancelEditing(): void {
    if (this.inputField?.nativeElement) {
      this.inputField.nativeElement.value = this.initialValue;
      this.isEditMode = false;
    }
  }
}
